import { createContext, type ReactNode, useContext } from 'react';

const initialViewer = () => {};

export const PageViewerContext =
  createContext<(content: ReactNode | undefined) => void>(initialViewer);

export const usePageViewer = () => {
  const pageViewerContext = useContext(PageViewerContext);
  if (pageViewerContext === initialViewer) {
    throw new Error('usePageViewer needs to used within a PageViewerContext');
  }
  return pageViewerContext;
};
